import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import {HttpService} from './http.service';
import {UtilService} from './util.service';
import {LoaderService} from './loader.service';
import {environment} from '../../../environments/environment';

@Injectable()
export class UserManagementService {
  constructor(
    private http: HttpService,
    private utilService: UtilService,
    private loaderService: LoaderService
  ) {
  }

  showLsaAdmins() {
    return this.http.get(`${environment.ROLE !== 'lsa' ? '/LoyaltySuperAdmin' : ''}/getLoyaltyUsers`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getProfile(id) {
    return this.http
      .get(`${environment.ROLE !== 'lsa' ? '/LoyaltySuperAdmin' : ''}/getLoyaltyUser?userId=` + id)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  changeLsaStatus(id, status) {
    return this.http
      .get(`${environment.ROLE !== 'lsa' ? '/LoyaltySuperAdmin' : ''}/activateOrDeactivate?userId=` + id + `&statusChange=` + status)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }


  profileUpdate(formData, isNew): any {
    this.loaderService.show();
    const url = isNew ? `addLoyaltySuperAdmin` : `updateLoyaltySuperAdmin`;
    const myToken = localStorage.getItem('loggedInUser') ? JSON.parse(localStorage.getItem('loggedInUser')).token : null;

    return Observable.create((observer) => {
      const xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            this.loaderService.hide();
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            this.loaderService.hide();
            observer.error(JSON.parse(xhr.response));
          }
        }
        return () => {
          this.loaderService.hide();
          xhr.abort();
        };
      };
      xhr.open('POST', `${environment.BASE_API}${environment.ROLE !== 'lsa'
        ? '/LoyaltySuperAdmin' : ''}${environment.ROLE}/${url}`, true);
      xhr.setRequestHeader('X-Auth-Token', myToken);
      xhr.send(formData);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/_services/user-management.service.ts